const chatConfig = {
  config: {
    apiChatStartURL: "getUUIDurl",
    introText: "Hi! Nice to meet you.",
    teaser: "Hey there, is there something I can help you find?",
    createURL: "testLeadCreateUrl",
  },
  modules: {
    "1": {
      action: 5,
      key: "first_name",
      text: "What is your name?",
      type: "text",
    },
    "5": {
      action: null,
      answers: [
        {
          action: 2,
          text: "Pricing",
        },
      ],
      key: "what",
      text: "{firstName}, what would you like assistance with?",
      type: "option",
    },
    "2": {
      action: null,
      answers: [
        {
          action: 3,
          text: "Assisted Living",
        },
        {
          action: 3,
          text: "Respite Care",
        },
        {
          action: 3,
          text: "Memory Care",
        },
        {
          action: 3,
          text: "Retirement Living",
        },
      ],
      key: "care",
      text: "Which of the following services are you are interested in, {firstName}?",
      type: "option",
    },
    "3": {
      action: null,
      answers: [
        {
          action: 4,
          text: "Parent",
        },
        {
          action: 4,
          text: "Spouse",
        },
        {
          action: 4,
          text: "Myself",
        },
        {
          action: 4,
          text: "Relative",
        },
      ],
      key: "who",
      text: "Who is this for?",
      type: "option",
    },
    "4": {
      action: null,
      answers: [
        {
          action: 7,
          text: "Immediately",
        },
        {
          action: 7,
          text: "1 to 3 Months",
        },
        {
          action: 7,
          text: "3 Months +",
        },
        {
          action: 7,
          text: "Just Researching",
        },
      ],
      key: "when",
      text: "What is your timeline?",
      type: "option",
    },
    "6": {
      action: 7,
      key: "phone",
      text: "{firstName}, what is your cell phone number?",
      type: "phone",
    },
    "7": {
      action: 8,
      key: "email",
      text: "What is your email? We will use this to indentify your quote in our systems",
      type: "email",
    },
    "8": {
      action: 10,
      key: "tour_date",
      text: "When would you like to visit, {firstName}?",
      type: "date_picker",
    },
    // Not submitting the lead in Selenium tests.
    // "9": {
    //   action: 10,
    //   key: null,
    //   text: "",
    //   type: "submit",
    // },
    "10": {
      action: null,
      answers: [
        {
          action: null,
          text: "Close Bot",
        },
        {
          action: 1,
          text: "Go Back To Start",
        },
      ],
      key: "more",
      text:
        "{firstName}, The price of our community starts at $3,000. Please schedule a visit to learn more about Testing Community.",
      type: "option",
    },
  },
};

export default chatConfig;
